import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { SMILEY_ICONS } from 'constants/engagement';
import './styles.scss';

const QuestionOption = ({
    idx, option, isSelected, selectAnswer, hideIcon
}) => {
    return (
        <div
            className={ `option-select ${ isSelected ? 'selected-option' : '' } ${ hideIcon ? 'extra-question' : 'normal-question' }` }
            onClick={ (e) => selectAnswer(idx + 1, e) }>
            <div className='hot-key'>{idx + 1}</div>
            {!hideIcon && <img
                src={ SMILEY_ICONS[idx] }
                alt='motivator-icon' />}
            <div className='question-answer' dangerouslySetInnerHTML={ { __html: i18n.t(option.title) } } />
        </div>
    );
};

QuestionOption.propTypes = {
    idx: PropTypes.number,
    option: PropTypes.object,
    isSelected: PropTypes.bool,
    selectAnswer: PropTypes.func,
    hideIcon: PropTypes.bool
};

QuestionOption.defaultProps = {
    idx: 0,
    option: {},
    isSelected: false,
    selectAnswer: null,
    hideIcon: null
};

export default QuestionOption;
